import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { NotFoundComponent } from './errors/not-found/not-found.component';
import { BulletinFormComponent } from './bulletins/bulletin-form/bulletin-form.component';
import { BulletinListComponent } from './bulletins/bulletin-list/bulletin-list.component';
import { BulletinReportComponent } from './bulletins/bulletin-report/bulletin-report.component';
import { HomeComponent } from './core/home/home.component';
import { VehicleComponent } from './masters/vehicle/vehicle.component';
import { RepairGroupComponent } from './masters/repair-group/repair-group.component';
import { BulletinTypeComponent } from './masters/bulletin-type/bulletin-type.component';
import { VehicleBrandComponent } from './masters/vehicle-brand/vehicle-brand.component';
import { RoleComponent } from './masters/role/role.component';
import { ParamComponent } from './masters/param/param.component';
import { MailComponent } from './masters/mail/mail.component';

import { VehicleResolver } from './masters/vehicle/vehicle.resolver';
import { VehicleBrandResolver } from './masters/vehicle-brand/vehicle-brand.resolver';
import { RepairGroupResolver } from './masters/repair-group/repair-group.resolver';
import { BulletinTypeResolver } from './masters/bulletin-type/bulletin-type.resolver';
import { RoleResolver } from './masters/role/role.resolver';
import { ParamResolver } from './masters/param/param.resolver';
import { MailResolver } from './masters/mail/mail.resolver';

import { MsalGuard } from '@azure/msal-angular';
import { TdbOnlyGuard } from './core/auth/tdbOnly.guard';

const routes: Routes = [
  { 
    path: '', 
    component: BulletinListComponent,
    canActivate: [MsalGuard],
    data: {
        title: 'Bulletin List'
    }
  },
  { 
    path: 'bulletin/add', 
    component: BulletinFormComponent,
    canActivate: [MsalGuard, TdbOnlyGuard],
    data: {
        title: 'Bulletin upload'
    }
  },
  { 
    path: 'bulletin/:id', 
    component: BulletinFormComponent,
    canActivate: [MsalGuard],
    data: {
        title: 'Bulletin upload'
    }
  },
  { 
    path: 'bulletins', 
    component: BulletinListComponent,
    canActivate: [MsalGuard],
    data: {
        title: 'Bulletin List'
    }
  }, 
  { 
    path: 'vehicles', 
    component: VehicleComponent,
    canActivate: [MsalGuard, TdbOnlyGuard],
    resolve: {
      items: VehicleResolver
    },
    data: {
        title: 'Vehicles'
    }
  },
  { 
    path: 'vehicle-brands', 
    component: VehicleBrandComponent,
    canActivate: [MsalGuard, TdbOnlyGuard],
    resolve: {
      items: VehicleBrandResolver
    },
    data: {
        title: 'Vehicle Brands'
    }
  },
  { 
    path: 'repair-groups', 
    component: RepairGroupComponent,
    canActivate: [MsalGuard, TdbOnlyGuard],
    resolve: {
      items: RepairGroupResolver
    },
    data: {
        title: 'Repair Groups'
    }
  },
  { 
    path: 'roles', 
    component: RoleComponent,
    canActivate: [MsalGuard, TdbOnlyGuard],
    resolve: {
      items: RoleResolver
    },
    data: {
        title: 'Roles'
    }
  },
  { 
    path: 'params', 
    component: ParamComponent,
    canActivate: [MsalGuard, TdbOnlyGuard],
    resolve: {
      items: ParamResolver
    },
    data: {
        title: 'Parameterization'
    }
  },
  { 
    path: 'mails', 
    component: MailComponent,
    canActivate: [MsalGuard, TdbOnlyGuard],
    resolve: {
      items: MailResolver
    },
    data: {
        title: 'E-mails'
    }
  },
  { 
    path: 'bulletin-types', 
    component: BulletinTypeComponent,
    canActivate: [MsalGuard, TdbOnlyGuard],
    resolve: {
      items: BulletinTypeResolver
    },
    data: {
        title: 'Bulletin Types'
    }
  },
  { 
    path: 'bulletin-report', 
    component: BulletinReportComponent,
    canActivate: [MsalGuard],
    data: {
        title: 'Bulletin Report'
    }
  }, 
  { 
    path: 'not-found', 
    component: NotFoundComponent,
    canActivate: [MsalGuard],
    data: {
        title: 'Not found'
    }
  },       
  { 
    path: '**', 
    canActivate: [MsalGuard],
    redirectTo: 'not-found'
    
  } 
];

const isIframe = window !== window.parent && !window.opener;

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    useHash: true,
    // Don't perform initial navigation in iframes
    initialNavigation: !isIframe ? 'enabled' : 'disabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
